import Tabs from './tabs';
import TabItem from './tabItem';

export {
  TabItem,
};

export default Tabs;
